<template>
  <!-- 四象限 -->
  <div class="window" style="width: 100%">
    <div class="nav">
      <div class="nav-lt">
        <img
          class="nav-lt-img"
          src="../../assets/img/home/center/whole.png"
          alt=""
          @click="displayleft"
        />
        <div class="nav-lt-tit">四象限</div>
      </div>
      <div class="nav-rt">
        <el-switch
          class="nav-rt-sw"
          v-model="switchVal"
          :width="33"
          active-color="#13ce66"
          inactive-color="#bbbbbc"
          @change="switchChang"
        >
        </el-switch>
        <div class="nav-rt-txt">显示已完成</div>
      </div>
    </div>

    <div class="main" ref="viewBox">
      <div class="main-box" style="background-color: #ec7259">
        <div class="main-box-tp" @click="tolist('重要紧急')">
          <div class="main-box-tp-lt">
            <div class="main-box-tp-lt-txt">
              重要紧急（{{ important.length }}）
            </div>
          </div>
        </div>
        <div class="main-box-bt">
          <input
            type="text"
            placeholder="添加任务"
            v-model="addfour1"
            @keyup.enter="foursubmit1()"
          />
          <div
            class="main-box-bt-con"
            :class="deleLine1 == index ? 'delecls' : ''"
            v-for="(item, index) in important"
            :key="index"
            v-show="
              switchVal
                ? !item.task_status || item.task_status
                : !item.task_status
            "
          >
            <div class="main-box-bt-cont">
              <div>
                <img
                  @click.stop="chooseCheak(item, index, 1)"
                  class="main-box-bt-cont-img"
                  v-show="!item.task_status"
                  src="../../assets/img/list/uncomplete.png"
                  alt=""
                />
                <img
                  class="main-box-bt-cont-img"
                  v-show="item.task_status"
                  style="opacity: 0.1"
                  src="../../assets/img/list/complete.png"
                  alt=""
                />
              </div>
              <div
                class="main-box-bt-cont-txt"
                :style="{ opacity: !item.task_status ? '' : '.5' }"
              >
                {{ item.task_name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-box" style="background-color: #f6a801">
        <div class="main-box-tp" @click.stop="tolist('重要不紧急')">
          <div class="main-box-tp-lt">
            <div class="main-box-tp-lt-txt">
              重要不紧急（{{ important2.length }}）
            </div>
          </div>
          <!-- <img
              class="main-box-tp-rt"
              src="../../assets/img/list/add.png"
              alt=""
            /> -->
        </div>
        <div class="main-box-bt">
          <input
            type="text"
            placeholder="添加任务"
            v-model="addfour2"
            @keyup.enter="foursubmit2()"
          />
          <div
            class="main-box-bt-con"
            :class="deleLine2 == index ? 'delecls' : ''"
            v-for="(item, index) in important2"
            :key="index"
            v-show="
              switchVal
                ? !item.task_status || item.task_status
                : !item.task_status
            "
          >
            <div class="main-box-bt-cont">
              <div>
                <img
                  @click.stop="chooseCheak(item, index, 2)"
                  class="main-box-bt-cont-img"
                  v-show="!item.task_status"
                  src="../../assets/img/list/uncomplete.png"
                  alt=""
                />
                <img
                  class="main-box-bt-cont-img"
                  v-show="item.task_status"
                  src="../../assets/img/list/complete.png"
                  alt=""
                />
              </div>
              <div
                class="main-box-bt-cont-txt"
                :style="{ opacity: !item.task_status ? '' : '.5' }"
              >
                {{ item.task_name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-box" style="background-color: #b78efc">
        <div class="main-box-tp" @click.stop="tolist('不重要紧急')">
          <div class="main-box-tp-lt">
            <div class="main-box-tp-lt-txt">
              不重要紧急（{{ unimportant.length }}）
            </div>
          </div>
          <!-- <img
              class="main-box-tp-rt"
              src="../../assets/img/list/add.png"
              alt=""
            /> -->
        </div>
        <div class="main-box-bt">
          <input
            type="text"
            placeholder="添加任务"
            v-model="addfour3"
            @keyup.enter="foursubmit3()"
          />
          <div
            class="main-box-bt-con"
            :class="deleLine3 == index ? 'delecls' : ''"
            v-for="(item, index) in unimportant"
            :key="index"
            v-show="
              switchVal
                ? !item.task_status || item.task_status
                : !item.task_status
            "
          >
            <div class="main-box-bt-cont">
              <div>
                <img
                  @click.stop="chooseCheak(item, index, 3)"
                  class="main-box-bt-cont-img"
                  v-show="!item.task_status"
                  src="../../assets/img/list/uncomplete.png"
                  alt=""
                />
                <img
                  class="main-box-bt-cont-img"
                  v-show="item.task_status"
                  src="../../assets/img/list/complete.png"
                  alt=""
                />
              </div>
              <div
                class="main-box-bt-cont-txt"
                :style="{ opacity: !item.task_status ? '' : '.5' }"
              >
                {{ item.task_name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-box" style="background-color: #90d034">
        <div class="main-box-tp" @click.stop="tolist('不重要不紧急')">
          <div class="main-box-tp-lt">
            <div class="main-box-tp-lt-txt">
              不重要不紧急（{{ unimportant2.length }}）
            </div>
          </div>
          <!-- <img
              class="main-box-tp-rt"
              src="../../assets/img/list/add.png"
              alt=""
            /> -->
        </div>

        <div class="main-box-bt">
          <input
            type="text"
            placeholder="添加任务"
            v-model="addfour4"
            @keyup.enter="foursubmit4()"
          />
          <div
            class="main-box-bt-con"
            :class="deleLine4 == index ? 'delecls' : ''"
            v-for="(item, index) in unimportant2"
            :key="index"
            v-show="
              switchVal
                ? !item.task_status || item.task_status
                : !item.task_status
            "
          >
            <div class="main-box-bt-cont">
              <div>
                <img
                  @click.stop="chooseCheak(item, index, 4)"
                  class="main-box-bt-cont-img"
                  v-show="!item.task_status"
                  src="../../assets/img/list/uncomplete.png"
                  alt=""
                />
                <img
                  class="main-box-bt-cont-img"
                  v-show="item.task_status"
                  src="../../assets/img/list/complete.png"
                  alt=""
                />
              </div>
              <div
                class="main-box-bt-cont-txt"
                :style="{ opacity: !item.task_status ? '' : '.5' }"
              >
                {{ item.task_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-slider
      class="slider"
      v-model="scrollVal"
      :show-tooltip="false"
      :format-tooltip="formatTooltip"
    ></el-slider>
    <!-- 左侧边栏 -->
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
      size="288px"
    >
      <left-nav></left-nav>
    </el-drawer>
  </div>
</template>

<script>
import leftNav from "../../components/content/leftNav";
import bus from "./../../util/bus";
export default {
  components: {
    leftNav,
  },
  data() {
    return {
      scrollVal: 0,
      switchVal: false,
      //重要
      important: [],
      //重要不紧急
      important2: [],
      //不重要紧急
      unimportant: [],
      //不重要不紧急
      unimportant2: [],

      listwhole: "",
      addfour1: "",
      addfour2: "",
      addfour3: "",
      addfour4: "",

      //控制已完成动画
      deleLine1: -1,
      deleLine2: -1,
      deleLine3: -1,
      deleLine4: -1,
      drawer: false,
    };
  },
  created() {
    this.fourlist(0);
    this.fourlist(1);
    this.fourlist(2);
    this.fourlist(3);
  },
  methods: {
    //左边显示
    displayleft() {
      if (document.body.clientWidth <= 1200) {
        this.drawer = true;
      }
    },
    fourlist(index) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .fourquadr(index, header)
        .then((res) => {
          console.log(res, "四象限");
          this.deleLine1 = -1;
          this.deleLine2 = -1;
          this.deleLine3 = -1;
          this.deleLine4 = -1;
          if (index == 0) {
            this.important = res.data.result;
            console.log(this.important);
          } else if (index == 1) {
            this.important2 = res.data.result;
          } else if (index == 2) {
            this.unimportant = res.data.result;
          } else if (index == 3) {
            this.unimportant2 = res.data.result;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //发布规划
    foursubmit1() {
      console.log("发布规划");
      let data = {
        task_name: this.addfour1,
        type: 0,
      };
      this.submit(data);
    },
    foursubmit2() {
      console.log("发布规划");
      let data = {
        task_name: this.addfour2,
        type: 1,
      };
      this.submit(data);
    },
    foursubmit3() {
      console.log("发布规划");
      let data = {
        task_name: this.addfour3,
        type: 2,
      };
      this.submit(data);
    },
    foursubmit4() {
      console.log("发布规划");
      let data = {
        task_name: this.addfour4,
        type: 3,
      };
      this.submit(data);
    },
    submit(data) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .releasetodo(data, header)
        .then((res) => {
          //刷新左侧边栏
          bus.$emit("refreshLeft");
          this.fourlist(data.type);
          this["addfour" + (data.type + 1)] = "";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 显示隐藏
    switchChang(e) {
      console.log(e, "点击的switch的值");
      this.switchVal = e;
    },

    // 点击完成
    chooseCheak(item, index, judge) {
      var that = this;
      if (judge == 1) {
        this.deleLine1 = index;
        setTimeout(function () {
          that.chooseComplete(item);
        }, 1000);
      } else if (judge == 2) {
        this.deleLine2 = index;
        setTimeout(function () {
          that.chooseComplete(item);
        }, 1000);
      } else if (judge == 3) {
        this.deleLine3 = index;
        setTimeout(function () {
          that.chooseComplete(item);
        }, 1000);
      } else if (judge == 4) {
        this.deleLine4 = index;
        setTimeout(function () {
          that.chooseComplete(item);
        }, 1000);
      }
    },
    chooseComplete(item) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      let data = {
        todo_id: item.id,
      };
      this.$api
        .completed(data, header)
        .then((res) => {
          this.fourlist(item.type);
          console.log(res, "点击已完成");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 滑块
    formatTooltip(e) {
      console.log(
        e,
        "滑块的值",
        this.$refs.viewBox.clientWidth,
        "页面可视区的宽度"
      );
      console.log(this.$refs.viewBox.scrollWidth, "viewBox的总宽度");
      this.$refs.viewBox.scrollLeft =
        (this.$refs.viewBox.scrollWidth - this.$refs.viewBox.clientWidth) *
        (e / 100);
      console.log(this.$refs.viewBox.scrollLeft, "左边的值");
    },
    //跳转页面
    tolist(txt) {
      this.$router.push({ name: "fourlists", query: { tet: txt } });
    },
  },
};
</script>

<style lang="scss" scoped>
.window {
  width: 100%;
  height: 100%;
  border: 1rpx solid #f7f7f7;
  background-color: var(--color-theme);
}

.main::-webkit-scrollbar {
  display: none;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 30px 0;
  padding-top: 50px;

  &-lt {
    display: flex;
    align-items: center;
    &-img {
      width: 20px;
      height: 16px;
      margin: 0 35px 0 20px;
    }

    &-tit {
      font-size: 30px;
      font-weight: bold;
      color: #333;
    }
  }

  &-rt {
    display: flex;
    align-items: center;

    &-sw {
      width: 33px;
      height: 16px;
      span {
        height: 16px;
      }

      .el-switch__core {
        height: 16px !important;
      }
      .el-switch__core::after {
        height: 13px !important;
        width: 13px !important;
      }
    }

    &-txt {
      font-size: 16px;
      color: #666;
      margin: 0 40px 0 6px;
    }
  }
}

.main {
  width: 100%;
  height: calc(100% - 180px);
  overflow-x: scroll;
  display: flex;
  scrollbar-width: none;

  &-box {
    width: 322px;
    // height: 100%;
    border-radius: 10px;
    box-sizing: border-box;
    margin: 0 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;

    &-tp {
      width: 282px;
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;
      margin-bottom: 10px;
      border-bottom: 1px solid rgba(248, 232, 232, 0.3);

      &-lt {
        display: flex;
        align-items: center;

        &-img {
          width: 20px;
          height: 17px;
          margin-right: 20px;
        }

        &-txt {
          font-size: 18px;
          color: #fff !important;
        }
      }

      &-rt {
        width: 17px;
        height: 17px;
        cursor: pointer;
      }
    }

    &-bt {
      width: 100%;
      text-align: center;
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
      input {
        width: 100%;
        height: 35px;
        border: none;
        border-radius: 8px;
        background-color: #fff;
        padding-left: 10px;
      }
      &-con {
        width: 100%;
      }
      .delecls {
        text-decoration: line-through;
        opacity: 0.6;
        width: 0;
        padding: 0;
        transition: width 1s linear;
      }
      &-cont {
        width: 100%;
        display: flex;
        align-items: center;
        margin: 10px 0;
        overflow: hidden;

        &-img {
          width: 21px;
          height: 21px;
          margin-right: 20px;
        }

        &-txt {
          width: 100%;
          height: 35px;
          font-size: 15px;
          line-height: 35px;
          color: #fff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
        }
      }

      &-img {
        margin-top: 30%;
        width: 150px;
        height: 115px;
      }
    }
  }
}

.slider {
  width: 300px;
  margin: 0 auto;

  ::v-deep .el-slider__runway {
    height: 14px;
    border-radius: 7px;
    background-color: #e7e7e7;

    .el-slider__bar {
      display: none;
    }

    .el-slider__button-wrapper {
      width: 100px;
      height: 14px;
      border-radius: 7px;
      top: -3px;
      .el-slider__button {
        width: 50px;
        height: 14px;
        border: none;
        border-radius: 7px;
        background-color: #d5d5d7;
      }
      .el-slider__button:hover {
        cursor: pointer;
      }
    }
  }
}
</style>  